package com.evoapps.evoshift.voice

import androidx.compose.runtime.staticCompositionLocalOf

/**
 * SH-150: reads a text out loud on the voice screen, so an answer is heard hands-free (in the car).
 * Android provides text-to-speech (androidApp's MainActivity); elsewhere nothing is spoken: on iOS
 * Siri itself says the answer (iosApp/iosApp/VoiceIntents.swift).
 */
fun interface Speech {
    fun speak(text: String)
}

val LocalSpeech = staticCompositionLocalOf { Speech { } }
